var map = {
	"./add.svg": "./src/icons/svg/add.svg",
	"./close-h.svg": "./src/icons/svg/close-h.svg",
	"./close-h1.svg": "./src/icons/svg/close-h1.svg",
	"./close-m.svg": "./src/icons/svg/close-m.svg",
	"./close.svg": "./src/icons/svg/close.svg",
	"./close1.svg": "./src/icons/svg/close1.svg",
	"./close_new.svg": "./src/icons/svg/close_new.svg",
	"./colse-h.svg": "./src/icons/svg/colse-h.svg",
	"./completed.svg": "./src/icons/svg/completed.svg",
	"./copy-link-h.svg": "./src/icons/svg/copy-link-h.svg",
	"./copy-link.svg": "./src/icons/svg/copy-link.svg",
	"./delect-h.svg": "./src/icons/svg/delect-h.svg",
	"./delect.svg": "./src/icons/svg/delect.svg",
	"./delete-h.svg": "./src/icons/svg/delete-h.svg",
	"./delete.svg": "./src/icons/svg/delete.svg",
	"./down-h.svg": "./src/icons/svg/down-h.svg",
	"./down.svg": "./src/icons/svg/down.svg",
	"./error.svg": "./src/icons/svg/error.svg",
	"./failed.svg": "./src/icons/svg/failed.svg",
	"./history-s.svg": "./src/icons/svg/history-s.svg",
	"./history.svg": "./src/icons/svg/history.svg",
	"./icon.svg": "./src/icons/svg/icon.svg",
	"./img-change.svg": "./src/icons/svg/img-change.svg",
	"./list-close.svg": "./src/icons/svg/list-close.svg",
	"./list-open.svg": "./src/icons/svg/list-open.svg",
	"./load.svg": "./src/icons/svg/load.svg",
	"./login-s.svg": "./src/icons/svg/login-s.svg",
	"./login.svg": "./src/icons/svg/login.svg",
	"./mobile-add copy.svg": "./src/icons/svg/mobile-add copy.svg",
	"./mobile-add.svg": "./src/icons/svg/mobile-add.svg",
	"./no-history.svg": "./src/icons/svg/no-history.svg",
	"./open-h.svg": "./src/icons/svg/open-h.svg",
	"./open.svg": "./src/icons/svg/open.svg",
	"./pic_empty.svg": "./src/icons/svg/pic_empty.svg",
	"./pic_waring.svg": "./src/icons/svg/pic_waring.svg",
	"./previous.svg": "./src/icons/svg/previous.svg",
	"./processing-b.svg": "./src/icons/svg/processing-b.svg",
	"./processing.svg": "./src/icons/svg/processing.svg",
	"./return.svg": "./src/icons/svg/return.svg",
	"./select.svg": "./src/icons/svg/select.svg",
	"./semi-select.svg": "./src/icons/svg/semi-select.svg",
	"./success.svg": "./src/icons/svg/success.svg",
	"./tax-included.svg": "./src/icons/svg/tax-included.svg",
	"./tip.svg": "./src/icons/svg/tip.svg",
	"./unselect.svg": "./src/icons/svg/unselect.svg",
	"./upgrade-s.svg": "./src/icons/svg/upgrade-s.svg",
	"./upgrade.svg": "./src/icons/svg/upgrade.svg",
	"./upgrade2.svg": "./src/icons/svg/upgrade2.svg",
	"./upload-b.svg": "./src/icons/svg/upload-b.svg",
	"./upload.svg": "./src/icons/svg/upload.svg",
	"./uploading.svg": "./src/icons/svg/uploading.svg",
	"./waiting-b.svg": "./src/icons/svg/waiting-b.svg",
	"./waiting.svg": "./src/icons/svg/waiting.svg",
	"./yes.svg": "./src/icons/svg/yes.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/icons/svg sync \\.svg$";